import { put, call, takeEvery } from "redux-saga/effects";
import { axiosInstance, apiURL } from "constants/config";
import toast from "react-hot-toast";

import {
  storeBusinessRequested,
  storeBusinessSuccess,
  storeBusinessFail,
  loadBusinessRequested,
  loadBusinessSuccess,
  loadBusinessFail,
} from "./settingSlice";

export function* storeBusinessEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${apiURL}/default-setting`,
      action.payload
    );
    if (data?.succeeded) {
      yield put(storeBusinessSuccess(data));
      // yield call(loadOrderSettingsEffect, {
      //   payload: {},
      //   type: '',
      // });
      toast.success(data?.result);
    } else {
      toast.error("Failed to save settings. Please try again.");
      yield put(storeBusinessFail(data?.errors));
    }
  } catch (error: any) {
    toast.error(
      "An error occurred while saving settings. Please check your connection and try again."
    );
    yield put(storeBusinessFail(error.message));
  }
}

export function* loadBusinessEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/get-order-setting`
    );
    if (data?.succeeded) {
      yield put(loadBusinessSuccess(data));
    } else {
      yield put(loadBusinessFail(data?.errors));
    }
  } catch (error: any) {
    yield put(loadBusinessFail(error.message));
  }
}

export function* settingSaga(): Generator<any, void, any> {
  yield takeEvery(storeBusinessRequested, storeBusinessEffect);
  yield takeEvery(loadBusinessRequested, loadBusinessEffect);
}
